import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-account-security-tab',
    templateUrl: './account-security-tab.component.html',
    styleUrls: ['./account-security-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountSecurityTabComponent {
    @Input() twoFactorEnabled = false;
    @Input() mfaLocked = false;
    @Input() twoFactorBusy = false;
    @Output() changePassword = new EventEmitter<void>();
    @Output() twoFactorToggled = new EventEmitter<void>();
}
